import api from './api';

export const attendanceService = {
  checkIn: async (data) => {
    const response = await api.post('/attendance/check-in', data);
    return response.data;
  },

  checkOut: async (data) => {
    const response = await api.post('/attendance/check-out', data);
    return response.data;
  },

  getMyAttendance: async (params) => {
    const response = await api.get('/attendance/my-attendance', { params });
    return response.data;
  },

  getUserAttendance: async (userId, params) => {
    const response = await api.get(`/attendance/user/${userId}`, { params });
    return response.data;
  },

  getAttendanceReport: async (params) => {
    const response = await api.get('/attendance/report', { params });
    return response.data;
  }
};
